import { render, staticRenderFns } from "./EditorToolbar.vue?vue&type=template&id=668ba613&scoped=true"
import script from "./EditorToolbar.vue?vue&type=script&lang=js"
export * from "./EditorToolbar.vue?vue&type=script&lang=js"
import style0 from "./EditorToolbar.vue?vue&type=style&index=0&id=668ba613&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668ba613",
  null
  
)

export default component.exports